import Axios from "axios";
import { useSelector } from "react-redux";
import { getBaseURL } from "../../baseURL";
import ErrorIcon from '@mui/icons-material/Error';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import React, { useState, useEffect } from "react";
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import { green, red } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { Container, Paper, TextField, Snackbar, CircularProgress, Table, Fab, fabClasses, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import moment from "moment/moment";
import { Tooltip } from '@mui/material';

export const ManageSpecialAccessRequests = () => {
  const useStyles = makeStyles(theme => ({
        root: {
      padding: theme.spacing(3, 2),
      overflowX: 'auto',   // NEW - keep wide table inside the white Paper (scroll inside)
    },
    paperSpacing: {
      paddingTop: "30px",
    },
    fabProgress: {
      color: green[500],
      position: 'absolute',
      top: -18,
      left: -3,
      zIndex: 1,
    },
    wrapper: {
      margin: theme.spacing(1),
      position: 'relative',
    },
    buttonGreen: {
      backgroundColor: green[500],
      '&:hover': {
        backgroundColor: green[700],
      },
    },
    buttonRed: {
      backgroundColor: red[500],
      '&:hover': {
        backgroundColor: red[700],
      },
    }
  }));

  const classes = useStyles();

  const currentUser = useSelector(state => state.auth);
  const config = {
    headers: { 'Authorization': "Bearer " + currentUser.jwtIdToken.idToken }
  };

  const [isAdmin, setIsAdmin] = useState(null);
  const [AlertColor, setAlertColor] = useState("");
  const [SnackBarText, setSnackBarText] = useState("");
  const [SnackBarOpen, setSnackBarOpen] = useState(false);
  const [checkedRequests, setCheckedRequests] = useState(false);
    const [specialAccessRequests, setSpecialAccessRequests] = useState([]);
    const [comments, setComments] = useState("");
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const [durationOptions, setDurationOptions] = useState([]);
 const [defaultDuration, setDefaultDuration] = useState(null);

  useEffect(() => {
  if (specialAccessRequests.length < 1 && !checkedRequests) {

      Axios.get(`${getBaseURL()}/admin/specialaccessrequests/get`, config)
        .then((response) => {
          var requests = [...response.data];
          requests = requests.filter(x => x.document != null);
          requests.forEach(x => x.submitted = { Submitted: false, Error: false, Message: "" });
            setSpecialAccessRequests(requests);
          setCheckedRequests(true);
        })
    }

    if (isAdmin === null) {
      try {
        if (currentUser.user.permissions.find(p => p.permissionName === "System Admin").value === true) {
          setIsAdmin(true);
        }
        else {
          setIsAdmin(false);
        }
      }
      catch (error) {
        setIsAdmin(false);
      }

      if (!isAdmin) {
        try {
          if (currentUser.user.permissions.find(p => p.permissionName === "Special Access Admin").value === true) {
            setIsAdmin(true);
          }
          else {
            setIsAdmin(false);
          }
        }
        catch (error) {
          setIsAdmin(false);
        }
      }
    }
  }, []);

 // ===== NEW: load duration options from DB (separate from existing loading) =====
  useEffect(() => {
      if (!defaultDuration || !checkedRequests) return;
      setSpecialAccessRequests(prev => prev.map(item => {
        if (item.duration || (item.submitted && item.submitted.Submitted)) return item;
        const exp = calcExpiration(item.effectiveDate, defaultDuration);
        return exp
          ? { ...item, duration: defaultDuration, effectiveThrough: exp.format('YYYY-MM-DDTHH:mm:ss') }
          : item;
      }));
    }, [defaultDuration, checkedRequests]);


  useEffect(() => {
    Axios.get(`${getBaseURL()}/admin/specialaccessrequests/durations`, config)
      .then((response) => {
        const options = response.data || [];
        setDurationOptions(options);
        const def = options.find(d => d.isDefault) || options[0];
        setDefaultDuration(def ? def.days : null);
      })
      .catch((error) => {
        // If this fails, the page still works as before - dropdown just won't show
        console.log("Error loading durations: " + error);
      });
  }, []);

  
  //constant to hold the filter value
    const [filterNeed, setFilterNeed] = React.useState('All');

    // Logic to filter the list based on the selection
    const filteredRequests = specialAccessRequests.filter(item => {
        if (filterNeed === 'All') return true;
        return item.businessNeed === filterNeed;
    });
  const onPrintChange = (event) => {
    var requests = [...specialAccessRequests];
    requests.find(x => x.id == event.target.id).printRequested = event.target.checked;

    requests.find(x => x.id == event.target.id).effectiveThrough = moment(requests.find(x => x.id == event.target.id).effectiveDate).add(30, 'days');

    setSpecialAccessRequests(requests);
  }
// To set the dropdown option for changing business need

const businessNeeds = [
     "Local sourcing", 
        "Technical service request"];
    const [modifyNeed, setmodifyNeed] = useState("");
    const onReasonChange = (event,id) => {
        const newValue = event.target.value;

        // Create a new array with the updated businessNeed for that specific row
        const updatedRequests = specialAccessRequests.map((item) => {
            if (item.id === id) {
                return { ...item, businessNeed: newValue };
            }
            return item;
        });

        // Update main list state
        setSpecialAccessRequests(updatedRequests);
    };
        // ===== NEW: Access Duration =====

    // Expiration Date = Effective Date + Duration (days)
    const calcExpiration = (effectiveDate, days) => {
      if (!effectiveDate || !days) return null;
      const start = moment(effectiveDate, [moment.ISO_8601, 'MM/DD/YYYY', 'M/D/YYYY']);
      if (!start.isValid()) return null;
      return start.startOf('day').add(Number(days), 'days');
    };

    // When admin changes the dropdown -> recalculate Expiration Date for that row
    const onDurationChange = (event, id) => {
      const days = Number(event.target.value);
      setSpecialAccessRequests(prev => prev.map(item => {
        if (item.id !== id) return item;
        const exp = calcExpiration(item.effectiveDate, days);
        return {
          ...item,
          duration: days,
          // same format the API returns, so existing display is unchanged
          effectiveThrough: exp ? exp.format('YYYY-MM-DDTHH:mm:ss') : item.effectiveThrough
        };
      }));
    };
  
    
    // To update business need and comments
    const handleUpdate = (id) => {
        const requests=[...specialAccessRequests]
        
        const userRequest = specialAccessRequests.find(x => x.id === id);
        userRequest.comments=currentUser.user.email;
        
        const request = {
            id: id,
            businessNeed: userRequest.businessNeed,
            comments:userRequest.comments
        }
		
        Axios.post(`${getBaseURL()}/admin/specialaccessrequests/updatebusinessneed`, request, config)
            .then((response) => {
                setAlertColor("success")
                setSnackBarText("Updated Business Need");
                setSnackBarOpen(true);
				setSpecialAccessRequests(requests);
                
            })
            .catch((error) => {
                console.log("Error processing request. Error: " + error);
            });
    };

    
   
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarOpen(false);
  }
  const generateFutureDated = (daysCount) => {
    const today = new Date();
    today.setDate(today.getDate() + daysCount);
    return today;
  }
  const allowFutureApproval = (daysCount, getEffecDate) => {
    const today = new Date(getEffecDate);
    today.setDate(today.getDate() + daysCount);
    return today;
  }
  const formatDate = (date) => {
    return date.toISOString().slice(0, 19);
  };

  const approveDeny = (id, approve) => {
    debugger;
    const userRequest = specialAccessRequests.find(x => x.id === id);
    let actionDate;

    const today = moment();
    const futureDate = moment(userRequest.effectiveDate, 'YYYY-MM-DD');
    console.log(today.format('YYYY-MM-DD'));
    console.log(futureDate.format('YYYY-MM-DD'));

    if (!futureDate.isValid()) {
      console.log("Invalid", userRequest.effectiveDate);
    }
    console.log(today.isAfter(futureDate));

    if (today.isAfter(futureDate) === true) {
      actionDate = formatDate(generateFutureDated(30));
    } else {
      actionDate = formatDate(allowFutureApproval(30, userRequest.effectiveDate));
    }


    const request = {
      id: id,
      printApproved: userRequest.printRequested,
        state: approve,
      effectiveDate: userRequest.effectiveDate,
      effectiveThrough: actionDate,
      duration: userRequest.duration || defaultDuration || null
    }

    let requests = [...specialAccessRequests];

    if (approve) {
      requests.find(x => x.id === id).SendingApprove = true;
    }
    else {
      requests.find(x => x.id === id).SendingReject = true;
    }

    setSpecialAccessRequests(requests);

    Axios.post(`${getBaseURL()}/admin/specialaccessrequests/update`, request, config)
      .then((response) => {
        requests = [...specialAccessRequests];
        var message = "";
        setAlertColor("success")
        if (approve) {
          message = "APPROVED"
          setSnackBarText("The request for special access has been granted");
          setSnackBarOpen(true);
        }
        else {
          message = "REJECTED"
          setSnackBarText("The request for special access has been denied");
          setSnackBarOpen(true);
        }
        requests.find(x => x.id === id).submitted = { Submitted: true, Error: false, Message: message }
        requests.find(x => x.id === id).SendingApprove = false;
        requests.find(x => x.id === id).SendingReject = false;

        try {
          setSpecialAccessRequests(requests);
        }
        catch (error) {
          console.log(error);
        }
      })
      .catch((error) => {
        console.log("Error processing request. Error: " + error);
      });

    console.log("set array");
  }

  
  return (
    <Container maxWidth={false} disableGutters={true}>
      {isAdmin ?
        <Container maxWidth={false} disableGutters={true}>
                  <Typography variant="h4" gutterBottom>Manage Special Access Requests</Typography>
                  <FormControl style={{ marginBottom: '20px', minWidth: '250px' }}>
                  <InputLabel>Filter by Business Need</InputLabel>
                  <Select
                      value={filterNeed}
                      onChange={(e) => setFilterNeed(e.target.value)}
                      label="Filter by Business Need"
                  >
                      <MenuItem value="All">All Requests</MenuItem>
                      <MenuItem value="Local sourcing">Local Sourcing</MenuItem>
                      <MenuItem value="Technical service request">Technical Service Request</MenuItem>
                      </Select>
                  </FormControl>
          {filteredRequests.length > 0 ?
            <Paper className={classes.root}>
              <Table>
                <TableHead>
                  <TableCell>User</TableCell>
                  <TableCell>Drawing Name</TableCell>
                  <TableCell>Class Level</TableCell>
                  <TableCell>Version</TableCell>
                  <TableCell>Business Need</TableCell>
                  <TableCell>Case Number</TableCell>
                  <TableCell>Local sourcing approval number</TableCell>
                  <TableCell>Part Description</TableCell>

                  <TableCell>Justification</TableCell>
                  <TableCell>Effective Date <br />{'(Begins midnight UTC)'}</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Expiration Date <br />{'(Ends midnight next day UTC)'}</TableCell>
                  <TableCell>Print</TableCell>
                  <TableCell></TableCell>
                </TableHead>
                <TableBody>
                  {filteredRequests.map((item, index) => {
                    return (
                      <TableRow key={index.toString()}>
                        <TableCell>{item.user.email}</TableCell>
                        <TableCell>{item.document.drawingNumber}</TableCell>
                        <TableCell>{item.description}</TableCell>
                        <TableCell>{item.document.revision}</TableCell>
                            <TableCell>
                                {filterNeed === 'All' ? (
                                    <>
                                <select
                                    
                                    id={item.id}
                                    defaultValue={item.businessNeed} // Use defaultValue for initial render
                                    variant="standard"
                                    onChange={(e)=> onReasonChange(e,item.id)}
                                    label="Business Need"
                                    style={{ width: '190px', marginBottom: '5px' }}
                                >
                                    
                                    {businessNeeds.map((need, i) => (
                                        <option key={i} value={need}>{need}</option>
                                    ))}
                                </select>
                         

                                <button  onClick={() => handleUpdate(item.id)}>Update</button><br/>
								<Tooltip title={<h6>{item.comments?item.comments:"none"}</h6>}>
								<u> Last modified by </u>
                                        </Tooltip> 
                                    </>
                                ) : (
                                    <Typography>
                                        {item.businessNeed}
                                    </Typography>
                                )}
                  </TableCell> 
                        <TableCell>{item.businessNeedDescription}</TableCell>
                        <TableCell>{item.businessApprovalNumber}</TableCell>
                        <TableCell>{item.partDescription}</TableCell>
                        <TableCell>{item.businessNeedJustification}</TableCell>
                        <TableCell>{new Date(item.effectiveDate).toLocaleDateString()}</TableCell>
                        <TableCell>
          {!item.submitted.Submitted ? (durationOptions.length > 0 ? (<select value={item.duration || defaultDuration || ''}
          onChange={(e) => onDurationChange(e, item.id)} disabled={item.SendingApprove || item.SendingReject}
                   style={{ width: '90px' }}>
                    {durationOptions.map(d => (<option key={d.id} value={d.days}>{d.label}</option>))}
                              </select>) : null
                          ) : (<Typography>{(item.duration || defaultDuration) ? `${item.duration || defaultDuration} days` : ''}</Typography>)}
                        </TableCell>
                        <TableCell>{new Date(item.effectiveThrough).toLocaleDateString()}</TableCell>
                      

                        <TableCell>
                          <Checkbox
                            id={item.id}
                            color="primary"
                            checked={item.printRequested}
                            onChange={onPrintChange}
                          />
                        </TableCell>
                        <TableCell>
                          {!item.submitted.Submitted ?
                            <span>
                              <span className={classes.wrapper}>
                                <Fab
                                  id={item.userID}
                                  size="medium"
                                  color="primary"
                                  onClick={() => approveDeny(item.id, false)}
                                  disabled={item.SendingReject || item.SendingApprove}
                                >
                                  <ClearIcon />
                                </Fab>
                                {item.SendingReject && <CircularProgress size={52} className={classes.fabProgress} />}
                              </span>
                              <span className={classes.wrapper}>
                                <Fab
                                  size="medium"
                                  color="primary"
                                  onClick={() => approveDeny(item.id, true)}
                                  disabled={item.SendingReject || item.SendingApprove}
                                >
                                  <CheckIcon />
                                </Fab>
                                {item.SendingApprove && <CircularProgress size={52} className={classes.fabProgress} />}
                              </span>
                            </span>
                            : <Typography variant="button">{item.submitted.Message}</Typography>}
                        </TableCell>
                      </TableRow>
                    );

                  })}
                </TableBody>
              </Table>
            </Paper>
            :
            <Typography variant="subtitle1">No Requests Found</Typography>
          }
          <Snackbar
            open={SnackBarOpen}
            autoHideDuration={5000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            <Alert onClose={handleSnackbarClose} severity={AlertColor === "success" ? "success" : "error"}>
              {SnackBarText}
            </Alert>
          </Snackbar>
        </Container>
        :
        <Paper className={classes.root}>
          <Typography variant="h6">
            <ErrorIcon />&nbsp;Access Denied
          </Typography>
        </Paper>
      }
    </Container>
  )
}